
export class NonComplianceRiskRecommendation {
    constructor(
        public risk?: string,        
        public personId?: number,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/noncompliance-risk-recommendation.model.ts